import { addLocaleData } from 'react-intl';
import messages from 'depop-locale/it.json';
import data from 'react-intl/locale-data/it';

addLocaleData(data);

export default messages;



// WEBPACK FOOTER //
// ../src/client/supportedLocales/it.js